import BaseApi from '../../services/baseApi';

class ListBox {

    buildingList() {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/item/building',
            headers: {'Content-Type': 'application/json'},
        })
    }

    templateList() {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/item/template',
            headers: {'Content-Type': 'application/json'},
        })
    }

    userList(buildingId) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/item/units/?id='+buildingId,
            headers: {'Content-Type': 'application/json'},
        })
    }








}

export default new ListBox();
